import authStore   from '@/auth/auth.store'
import samlService from '@/auth/saml.service'
import VueKeyCloak from '@dsb-norge/vue-keycloak-js'
import Vue         from 'vue'

const conf = APP_CONFIG // eslint-disable-line

/** IS IE **/
const isIE = () => {
  const ua = window.navigator.userAgent

  const msie = ua.indexOf('MSIE ')
  if (msie > 0) {
    // IE 10 or older => return version number
    return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10)
  }

  const trident = ua.indexOf('Trident/')
  if (trident > 0) {
    // IE 11 => return version number
    const rv = ua.indexOf('rv:')
    return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10)
  }

  const edge = ua.indexOf('Edge/')
  if (edge > 0) {
    // Edge (IE 12+) => return version number
    return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10)
  }

  // other browser
  return false
}

/** BOOTSTRAP APP **/
const bootstrapApp = () => {

  import(/* webpackChunkName: "main" */ './bootstrapApp').then(createApp => {
    createApp.default()
  })

}

/** LOGIN SAML (EMPLOYEE) **/
const loginSaml = () => {

  samlService.authenticate({ skipAuth: false }).then(isAuthenticated => {
    if (isAuthenticated) {
      bootstrapApp()
    }
  })

}

const isSsoTokenQuery = () => {
  const query = window.location.search || ''
  query.match(/[&?]ssoToken=(.+)(&|$)/)
  return RegExp.$1
}

/** LOGIN KEYCLOAK (RETIRED) **/
const loginKeycloak = () => {

  Vue.use(VueKeyCloak, {
    init   : {
      onLoad          : 'login-required',
      checkLoginIframe: false,
    },
    config : {
      authRealm   : conf.keycloak.authRealm,
      authUrl     : conf.keycloak.authUrl,
      authClientId: conf.keycloak.authClientId,
    },
    onReady: (keycloak) => {
      // on sauvegarde le token
      authStore.keycloakToken = keycloak.token
      authStore.rcwId         = keycloak.tokenParsed['rcw_id']
      // on cree l'application
      bootstrapApp()
    },
  })

}

/** MAIN PART **/

if (isIE()) {
  window.location = '/static/download-chrome.html'
}

if (authStore.isAuthenticated()) {

  if (authStore.samlToken) {
    loginSaml()
  } else if (authStore.keycloakToken) {
    loginKeycloak()
  }

} else {

  const pathname = window.location.pathname

  if (pathname === '/startemployee' || isSsoTokenQuery()) {
    loginSaml()
  } else if (pathname === '/startretired') {
    loginKeycloak()
  } else {
    window.location = '/static/login.html'
  }

}





// WEBPACK FOOTER //
// ./src/main.js